var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"section-header"},[_c('h1',[_vm._v(_vm._s(_vm.$t("ui.dashboard"))+"  ")])]),(_vm.isOperator)?[_c('dashboardop')]:[_c('dashboardad')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }